import { Flex, Spin } from '@contiple/antd-ds';

const Loading = () => {
  return (
    <Flex
      style={{ height: '100vh', width: '100vw' }}
      align="center"
      justify="center">
      <Spin />
    </Flex>
  );
};

export default Loading;
